// Document categories for immigration cases
// Used in both Contact and Case document uploads

export const DOCUMENT_CATEGORIES = [
  { value: 'identity_civil', label: 'Identidade & Estado Civil' },
  { value: 'eligibility', label: 'Elegibilidade & Qualificação' },
  { value: 'government_forms', label: 'Formulário (Government Forms)' },
  { value: 'evidence_supporting', label: 'Evidências / Supporting Docs' },
  { value: 'correspondence_decisions', label: 'Correspondência & Decisões' },
  { value: 'submission_packet', label: 'Submissão / Packet / Filing' },
] as const;

export type DocumentCategory = typeof DOCUMENT_CATEGORIES[number]['value'];

// Helper to get label from value
export function getCategoryLabel(value: string | null): string {
  if (!value) return '—';
  const category = DOCUMENT_CATEGORIES.find(c => c.value === value);
  return category?.label || value;
}

// Categories that auto-link to all cases of a contact
export const AUTO_LINK_CATEGORIES: DocumentCategory[] = ['identity_civil'];

export function shouldAutoLinkToAllCases(category: string): boolean {
  return AUTO_LINK_CATEGORIES.includes(category as DocumentCategory);
}
